module.exports = __webpack_public_path__ + "img/Group 26986@2x.f8785bfa.png";